import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'searchText',
    standalone: true
})
export class SearchTextPipe implements PipeTransform {

  transform(value: any, query: string, field: string): any {
    return query ? value.reduce((prev, next) => {
      if ((next[field] || '').toUpperCase().includes(query.toUpperCase())) {
        prev.push(next);
      }
      return prev;
    }, []) : value;
  }
}
